import { QueryClient } from '@tanstack/react-query';
import apiClient from '@/api.ts';
import { LandownerRequest, LandownerResponse } from './types';
import { LandOwnerFormSchema } from './zodSchemas';

export const SITE_ROOT_API_URL = '/api/v1/sites';
export const LANDOWNER_ROOT_API_URL = '/api/v1/landowners';

export function listSites({ showAvailableSpaces = false }: { showAvailableSpaces?: boolean }) {
	return {
		queryKey: ['v1', 'sites'],
		queryFn: () => apiClient.get(`${SITE_ROOT_API_URL}?hasAvailableSpaces=${showAvailableSpaces}`)
	};
}

export function loader(queryClient: QueryClient) {
	return async () => {
		return {
			sites: await queryClient.ensureQueryData(listSites({ showAvailableSpaces: false }))
		};
	};
}

export function queryLandowners() {
	return {
		queryKey: ['v1', 'landowners'],
		queryFn: () => apiClient.get<LandownerResponse[]>(LANDOWNER_ROOT_API_URL)
	};
}

export function saveNewLandowner(landowner: LandownerRequest) {
	return apiClient.post(LANDOWNER_ROOT_API_URL, landowner);
}

export const toLandownerPayload = (landowner: LandOwnerFormSchema): LandownerRequest => {
	return {
		...landowner,
		mailingAddress: landowner.mailingAddress,
		mobile: landowner.mobile,
		initialDeploymentDate: landowner.initialDeploymentDate?.toISOString() ?? '',
		siteId: parseInt(landowner.site[0].value)
	};
};
